export default class SettingsPasswordController {
  handleChangePassword(profile) {
    this.errors = [];
    this.checkPasswordConfirmation(profile);
    if (!this.errors.length) {
      this.updating = true;
      profile.$changePassword()
        .then(() => {
          this.updating = false;
        })
        .catch((response) => {
          this.updating = false;
          this.errors = response.data.errors;
        })
    }
  }

  checkPasswordConfirmation(profile) {
    const isEqual = (profile.password === profile.password_confirmation);
    if (!isEqual) {
      this.errors.push("Passwords Don't Match");
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/screens/engineer/screens/settings/screens/settings-password/settings-password.controller.js